module.exports = __webpack_public_path__ + "img/welcome.f3f2ab05.png";